<template>
  <div>
    <div>
      <div class="feedbackPage">
        <div
          class="head-topbar lite-page-top linebottom sticky"
          style="background: rgb(255, 255, 255);"
        >
          <div class="topbar-left" @click="goto('/jnt/help')">
            <i class="icon-arrow-left"></i>
          </div>
          <div class="topbar-main"><h4>意见反馈</h4></div>
          <div class="topbar-right" @click="goto('/jnt/center/feedhistory')">
            <div>反馈记录</div>
          </div>
        </div>

        <div style="padding:1rem;">
          <div class="edittxt">
            <textarea v-model="feedback.content" placeholder="请填写您的问题或意见描述以便我们提供更好的帮助"></textarea>
          </div>
          <div class="input-group">
            <div class="inp-title">联系方式</div>
            <div class="inp-content">
              <input v-model="feedback.mobile" type="number" class="inp-content-input" placeholder="请输入手机号(选填)" />
            </div>
          </div>
          <div class="btn-submit"><span style="background:#15a892;" @click="submitFeedback()">提交</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'help',
  data() {
    return {
      feedback: {
        myId: this.$store.getters.userId,
        mobile: null,
        content: null,
      }
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    submitFeedback(){
      var that = this
      this.$submit('/api/msgfeedback/addFeedback', this.feedback, function(res) {
        if (res.code === 1) {
          that.$toast.success('提交意见反馈成功！')
        }
      })
    }
  },
  mounted(){
  },
  created() {
  },
  watch: {},
}
</script>

<style>
.feedbackPage {
  position: relative;
  /* padding: 0 15px; */
}
.feedbackPage .title {
  margin-top: 20px;
}
.feedbackPage .title .txt1 {
  color: #333;
  font-size: 1.4rem;
}
.feedbackPage .title .txt2 {
  color: #b16d4e;
  font-size: 1.1rem;
  float: right;
  margin-top: 2px;
  position: relative;
  padding-right: 14px;
}
.feedbackPage .title .txt2:after {
  content: '';
  width: 12px;
  height: 12px;
  position: absolute;
  top: 2px;
  right: 0;
  background: url(../../../assets/jnt/oright.png) no-repeat;
  background-size: 100% 100%;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.feedbackPage .edittxt {
  padding: 10px 0;
}
.feedbackPage .edittxt textarea {
  padding: 15px;
  width: 100%;
  border: none;
  box-sizing: border-box;
  border-radius: 10px;
  line-height: 20px;
  height: 140px;
  color: #000;
  font-size: 1.2rem;
  -webkit-appearance: none;
}
input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}
.feedbackPage .input-group {
  height: 52px;
  border-radius: 10px;
  background: #fff;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding-left: 17px;
  margin-bottom: 11px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  font-size: 1.2rem;
}
.input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}
.feedbackPage .input-group .inp-title {
  width: 74px;
}
.feedbackPage .input-group .inp-content {
  display: block;
  line-height: 1.4em;
  height: 1.4em;
  min-height: 1.4em;
  overflow: hidden;
  webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.feedbackPage .input-group .inp-content .inp-content-input {
  display: block;
  height: 100%;
  width: 100%;
  color: #333;
  font: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-indent: inherit;
  text-transform: inherit;
  text-shadow: inherit;
  border: none;
}
input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}
.feedbackPage .btn-submit {
  padding-top: 15px;
}
.feedbackPage .btn-submit span {
  display: block;
  width: 100%;
  height: 3.6rem;
  background: #e4803c;
  color: #fff;
  text-align: center;
  line-height: 3.6rem;
  border-radius: 20px;
  font-size: 1.4rem;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}
.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/zjt1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
